var app_ajax = null;
(function ($) {
  app_ajax = function (_url, _template_name) {
    var self = this;
    self.url = _url;
    self.doing_ajax = false;
    self.template = wp.template(_template_name);
    self.current_template = null;
    self.scrollPosition = 0;

    self.defaultTitle = $(document).prop("title");
    self.defaultLocation = window.location;
    self.bf = "forward";
    self.current_id = 0;
    self.timer = null;
    self.offsetTop = 0;

    self.cache = [];

    // Click listener for closing modal when clicking outside
    $(document).on("click", function (event) {
      if (
        self.current_template &&
        $("body").hasClass("as-is-open") &&
        !$(event.target).closest(self.current_template).length
      ) {
        self.close(event);
      }
    });

    self.do_ajax = function (id, offsetTop) {
      if (!undef(id) && !self.doing_ajax) {
        self.current_id = id;
        self.doing_ajax = true;
        self.reset_template();
        self.offsetTop = offsetTop ? offsetTop : 0;

        // if (typeof self.cache[id] !== "undefined") {
        //     console.log(self.cache);
        //   self.ajax_complete(self.cache[id]);
        // } else {
        // }
        $.getJSON(self.url + "/" + id, self.ajax_complete.bind(self));
      }
    };

    self.ajax_complete = function (data) {
      self.doing_ajax = false;

      
      if (data) {
          self.cache[data.ID] = data;
          self.bf = "backward";
          self.scrollPosition = $(window).scrollTop();
          
          console.log(data);
        self.current_template = $("<div/>", {
          class: "mustache-single-apartment-wrapper",
          html: self.get_template(data),
        });

        self.current_template.find("a.sa-close-btn").on("click", self.close);

        $("body").addClass("as-is-open");
        $("body").append(self.current_template);
        self.current_template.css({top: self.offsetTop + "px"});
        $(window).trigger("resize");
      }
    };

    self.close = function (event) {
      if (event) event.stopImmediatePropagation();
      self.reset_template();
    };

    self.changeUrl = function (id, page, url) {
      if (typeof history.pushState !== "undefined") {
        history.pushState({ id: id }, page, url);
        $(document).prop("title", page);
        $(window).on("popstate", self.history);
      } else {
        console.log("cant change url... old browser");
      }
    };

    self.get_template = function (data) {
      return self.template(data);
    };

self.reset_template = function () {
  $("body").removeClass("as-is-open");
  if (self.current_template !== null) {
    self.current_template.remove();
  }
  self.current_template = null;
  $(window).trigger("resize");
};

    self.history = function (event) {
      event.preventDefault();
      if (
        typeof event === "object" &&
        typeof event.type !== "undefined" &&
        event.type === "popstate"
      ) {
        switch (self.bf) {
          case "forward":
            self.do_ajax(self.current_id);
            break;
          case "backward":
            self.close_template(event);
            break;
        }
      }
    };

    self.close_template = function () {
      self.current_template.fadeOut(500, function () {
        self.bf = "forward";
        $(document).prop("title", self.defaultTitle);
        self.changeUrl(1, self.defaultTitle, self.defaultLocation);
        $("body").removeClass("as-is-open as-closing");
        self.reset_template();

        $("html, body").stop().animate(
          {
            scrollTop: self.scrollPosition,
          },
          0
        );
      });
    };

    return self;
  };
})(jQuery, window, document);
